import React from "react";
import { IS_REF_MOBILE } from "../../../utils/refViewport";
import { formatOdds, formatAmount } from "../../../utils/formatOdds";
import { latestBets } from "../../../utils/casinoMyBets";

function formatBetDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

/**
 * Reference vcasino RightSideBar (vdtl20 / vbtable; copied from lucky7/VCasinoRightSide): My Bets card with the
 * 3-column table (UserName / Rate / Amount). These games have no rules card (reference renders <!---->).
 */
export default function VirtualRightSide({ bets = [], onViewMore }) {
  const list = latestBets(bets); // latest 10, like the reference
  return (
    <>
      <div className="card m-b-10 my-bet" id={IS_REF_MOBILE ? "casino-bets" : undefined}>
        <div className="card-header">
          <h6 className="card-title float-left">My Bets</h6>{" "}
          <a
            href="#"
            className="btn btn-back float-right"
            onClick={(e) => {
              e.preventDefault();
              if (typeof onViewMore === "function") onViewMore();
            }}
          >
            View More
          </a>
        </div>{" "}
        <div className="card-body1">
          <div className="tab-content">
            <div id="matched-bet" className="tab-pane active">
              <div className="table-responsive1">
                <table className="table coupon-table table-striped mb-0">
                  <thead>
                    <tr>
                      <th style={{ minWidth: "90px" }}>UserName</th>
                      <th className="text-right" style={{ minWidth: "50px" }}>Rate</th>
                      <th className="text-right" style={{ minWidth: "70px" }}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.length === 0 ? (
                      <tr>
                        <td colSpan={4} className="text-center">No records found</td>
                      </tr>
                    ) : (
                      list.map((bet, i) => {
                        const t = String(bet.type || bet.gametype || "").toLowerCase();
                        const border = t === "lay" ? "lay-border" : t === "back" ? "back-border" : undefined;
                        return (
                          <React.Fragment key={bet.id || i}>
                            <tr className={border}>
                              <td colSpan={4}>
                                <b>{bet.selection || bet.matchedBet || "-"}</b>{" "}
                                <span className="float-right">{formatBetDate(bet.placeDate)}</span>
                              </td>
                            </tr>
                            <tr className={border}>
                              <td>{bet.userName}</td>
                              <td className="text-right">{formatOdds(bet.odds)}</td>
                              <td className="text-right">{formatAmount(bet.stake)}</td>
                            </tr>
                            <tr>
                              <td colSpan={4} style={{ height: "3px", padding: 0 }} />
                            </tr>
                          </React.Fragment>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
